import React, { createContext, useState } from 'react'
export const AlertContext = createContext([])

const AlertContextProvider = ({ children }) => {
    const [alerts, setAlerts] = useState([])
    return <AlertContext.Provider value={{ alerts, setAlerts }}>{children}</AlertContext.Provider>
}

export default AlertContextProvider
